<template>
  <div class="store-page" @scroll="scrollFn">
    <Header></Header>
    <div class="store-list" v-if="storeList.length">
      <div class="store-item" v-for="item in storeList" :key="item.storeId">
        <div class="store-title">
          <h4 @click="look(item)"><p>{{item.storeAliasName}}</p> <span>官方认证</span></h4>
          <div @click="look(item)">进店 <i></i></div>
        </div>
        <div class="store-tag">
          <span>商品描述 <small>{{item.productScore || 0}}</small></span>
          <span>卖家服务 <small>{{item.sellerServiceScore || 0}}</small></span>
          <span>物流服务 <small>{{item.logisticsScore || 0}}</small></span>
        </div>
        <div class="store-body">
          <div v-for="prod in item.membersImages" :key="prod.productId" @click="goDetail(prod, item.mdCode)"><img :src="prod.defaultImageUrl" alt=""></div>
        </div>
      </div>
    </div>
    <div v-else-if="loadEnd && !storeList.length" class="empty-store">
      <img src="https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/order/nodata.png" alt="">
      <p>暂无店铺</p>
    </div>
    <div class="loading" id="loading">
      <p v-if="loading && !loadEnd">加载中...</p>
      <p v-else>到底了~</p>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import Url from '@/http/url'
import { mapGetters } from 'vuex'

import { commonLoadItemNew } from '@/http/service/shop'

export default {
  name: 'vipstore',
  components: {
    Header
  },
  data() {
    return {
      // shareShow: this.$util.isHaierApp() || this.$util.isSgRn(),
      storeList: [],
      loading: false,
      loadEnd: false,
      curPage: 1,
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters({
      location: 'getlocationInfo',
    })
  },
  mounted() {
    if (this.$util.isHaierApp()) {
      this.$store.dispatch('handleUpAuth').then(isLogin => {
        // 登陆正常 调用加购接口
        if (isLogin) {
          this.fetchData()
        } else {
          this.$store.dispatch('doLogin')
        }
      })
    } else {
      if (this.$store.getters.getLoginStatus) {
        this.fetchData()
      }
    }
  },
  methods: {
    scrollFn(ev) {
      let scrollTop = ev.target.scrollTop
      let loadingTop = document.getElementById('loading')?.getBoundingClientRect().top;
      let winH = window.innerHeight;
      console.log(scrollTop, loadingTop, winH)
      if (scrollTop > loadingTop - winH) {
        this.fetchData()
      }
    },
    fetchData() {
      console.log('fetch')
      if (this.loading || this.loadEnd) return;
      this.loading = true
      this.$http.get(Url.vipStoreNew, {
        params: {
          latitude: this.location.latitude,
          longitude: this.location.longitude,
          start: this.curPage,
          offset: this.pageSize
        }
      }).then(res => {
        let result = res.data;
        this.loading = false
        if (result.success) {
          let arr = this.getItemProductImg(result.data?.memberStore || []) // 循环请求获取每项数据
          this.storeList = this.storeList.concat(arr)
          this.curPage += 1;
          if ((result.data?.memberStore?.length || 0) < this.pageSize) {
            this.loadEnd = true
          }
        } else {
          this.$toast(result.message);
        }
      })
    },
    goDetail(prod, mdCode) {
      this.$router.push({
        path: '/goodsDetail',
        query: {
          productId: prod.productId,
          mdCode: mdCode || ''
        }
      })
    },
    look(item) {
      this.$router.push({
        path: '/shopDetail',
        query: {
          storeId: item.storeId,
          mdCode: item.mdCode || ''
        }
      })
    },

    getItemProductImg(arr) {
      arr.forEach(item => {
        commonLoadItemNew({
          channal: 1,
          provinceId: this.location.provinceId,
          cityId: this.location.cityId,
          districtId: this.location.districtId,
          streetId: this.location.townshipId,
          visitStore: item.storeId,
          visitMdCode: item.mdCode || '',
          filterData: 'hasStock@all@0@',
          qs: 'saleDesc',
          fromType: 2,
          pageIndex: 1,
          pageSize: 10,
          longitude: this.location.longitude || '',
          latitude: this.location.latitude || '',
        }).then(res => {
          let result = res.data;
          console.log(result, '======result item=> ' + item.storeId + '========')
          item.membersImages = result.productList.splice(0, 3);
        })
      })
      return arr
    }

  }
}
</script>

<style lang="scss" scoped>
.store-page{
  padding-top: 1rem;
  box-sizing: border-box;
  height: 100%;
  overflow-y: scroll
}
.share-btn{
  display: inline-block;
  width: .36rem;
  height: .36rem;
  background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/icon/blackShareIcon.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.store-list{
  padding: .16rem .24rem;
}

.empty-store{
  padding-top: 1rem;
  text-align: center;
  img{
    display: inline-block;
    max-width: 2.4rem;
  }
  p{
    padding-top: .3rem;
    font-size: .28rem;
  }
}

.loading{
  padding: .4rem 0;
  text-align: center;
  font-size: .26rem;
  color: #999;
}

.store-item{
  margin-bottom: .16rem;
  padding: .24rem;
  border-radius: .24rem;
  background: #fff;
}

.store-title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: .12rem;
  h4{
    display: flex;
    align-items: center;
    p{
      max-width: 4rem;
      font-size: .28rem;
      line-height: .3rem;
      color: #333;
      font-weight: 500;
      @include text-overflow(1);
    }
    span{
      margin-left: .12rem;
      display: inline-flex;
      padding: .04rem .08rem;
      font-size: .16rem;
      background: #E2ECFB;
      color: $themeSynMain;
      border-radius: .04rem;
    }
  }
  div{
    display: flex;
    align-items: center;
    font-size: .24rem;
    color: $themeSynMain;
    i{
      margin-left: .05rem;
      display: inline-block;
      vertical-align: middle;
      width: .15rem;
      height: .2rem;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAkCAYAAAB4+EEtAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAG6ADAAQAAAABAAAAJAAAAADVfnuuAAACaUlEQVRIDbVXsU4bQRB9a6ykochHgBTbfT4CKRJBqaCgyUcAMhFCBPMFSQEooqBAihIkpHxEyki2lZCPSJEmku3NvLWR5va8d7t74Qrf7OzMPM/c25k7oObq7dm1Tt+u15hFbbeqrDr79v0UuLcT/Ozs2XNrramyr9sLOjMbgugAYtwfn5l3WpciBzNrTWD9QJLXsWS74etj10Gw4Zn5ZQxuCoEsaH+d+wyDYARpPcUbKd1QA1qLZ5jitndkV7U+Rq4EGx6ZP2KwKRn+1sEEsDv7i6tUwlSCEYDllNsODGYe4FZ3HwdaVyfXgjHAeGC+iuGhHyyVMEHqlwLLGese4JOUcEvvuRKv4MX4xNxr/TI5KjM6GmOsEGa3CWGiwQjYlDBJYA6wAWGSwQiYS5hoghBEXzxjqYTJyoyglYSZ4MuyDpMNRkASBm28KnUYoCcd5pI2+souow7CSSAj4k7mROHPP2nj+fcT8+PBtrD5oHyse2Owxbi59rPieNJZMYFGYI4EMm7c2FHlYJfheFIqJ2aDkfrzMYOuDkqySNBNRx69IXI2GMeL35Q5hgRsezGWPChgpaSJUDj2GZyLaYHNLYP+aGA+hkIUjENGWu8IMcW30nMy+Dw6xWsedm2v5aQy1hBitwqIoNFgOYTQWVFu+4rQ2hECxSm9eC/ZCRHCjxWV2YIQx0ucDzlufH1oXUuQJoTwQSszc4SQcVFi3rxD1BIiCUw6xIXwuKedqjqEtlsmB8vI7zJ+LhWc2CGAlynPSfsHyzhrF7sDneS4vs0Fon8QjC+dUrIPNOIlGV2MBjidrx7p939+5v4Dp8IFdy8HPqsAAAAASUVORK5CYII=) no-repeat;
      background-size: cover;
    }
  }
}

.store-tag{
  margin-bottom: .24rem;
  span{
    margin-right: .12rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: .04rem .06rem;
    background: #F7F7F7;
    color: #666;
    font-size: .16rem;
    small{
      margin-left: .08rem;
      color: $themeSynMain;
    }
  }
}

.store-body{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  div{
    margin-right: .24rem;
    width: 2.02rem;
    height: 2.02rem;
    border-radius: .16rem;
    overflow: hidden;
    &:last-child{
      margin-right: 0;
    }
    img{
      width: 2.02rem;
      height: 2.02rem;
    }
  }
}

</style>
